import React, { useEffect, useMemo, useState } from "react";
import Cookies from "universal-cookie";
import { Switch } from "react-router-dom";
import { PrivateRoute } from "core/components/PrivateRoutes";
import { Print } from "./scenes/Print";
import Dashboard from "./scenes/Dashboard";
import { Reports } from "./scenes/Reports";
import { Sidebar } from "core/components/Sidebar";
import { PrivateReports } from "core/components/PrivateRoutes/Reports";
import { PrivatePrint } from "core/components/PrivateRoutes/Print";
import { api } from "data/apollo/api";
import { useQuery } from "@apollo/client";
import moment from "moment";
import { SessionContext } from "data/context";
import { config } from "./config";
import { clearSessionRecoveryMarkers } from "data/helpers";

function App() {
  const cookies = new Cookies();
  const [session, setSession] = useState<any>({ ftusertype: 0 });
  const [dateRange, setDateRange] = useState({
    startDate:
      (cookies.get("foDateRange") && cookies.get("foDateRange").startDate) ||
      moment().startOf("month").format("YYYY-MM-DD"),
    endDate:
      (cookies.get("foDateRange") && cookies.get("foDateRange").endDate) ||
      moment().endOf("month").format("YYYY-MM-DD"),
  });
  const sessionQuery = useQuery(api.remote.query.getSessionInfo, {
    onError(error) {
      console.error("[sessionQuery]:", error);
    },
    onCompleted: (data) => {
      clearSessionRecoveryMarkers();
      setSession({
        ...data.sessionInfo,
        ftusertype: sessionQuery.data.sessionInfo.ftusertype.toString(),
      });
    },
  });
  const dealersQuery = useQuery(api.remote.query.getDealers, {
    onError(error) {
      console.error("[dealersQuery]:", error);
    },
  });
  const isLoading = dealersQuery.loading || sessionQuery.loading;

  const dealers = useMemo(() => {
    const dealerList = dealersQuery.data?.dealers;

    if (!dealerList) return {};

    return dealerList.reduce((map: any, dealer: any) => {
      map[dealer.idsid.toLowerCase()] = dealer.dealername;
      return map;
    }, {});
  }, [dealersQuery.data]);

  useEffect(() => {
    cookies.set("foDateRange", dateRange);
  }, [dateRange]);

  if (isLoading) {
    return <></>;
  }

  return (
    <SessionContext.Provider value={session}>
      <Switch>
        <Sidebar dealers={dealers} setDateRange={setDateRange}>
          <PrivateRoute
            path="/"
            component={Dashboard}
            dealers={dealers}
            dateRange={dateRange}
            setDateRange={setDateRange}
            exact
          />
          <PrivateReports
            path="/reports"
            component={Reports}
            dealers={dealers}
            dateRange={dateRange}
            setDateRange={setDateRange}
          />
          <PrivatePrint path="/print-voucher" component={Print} />
        </Sidebar>
      </Switch>
    </SessionContext.Provider>
  );
}

export default App;
